import { QcUserSchema } from "./QcUser";
import { UserProfileSchema } from "@/modules/auth/objects/userProfile";
import { MessageContentSchema } from "./MessageContent";
import { MessageActionSchema } from "./MessageAction";
import { z } from "zod";

export type Message = z.infer<typeof MessageSchema>;
export const MessageSchema = z.object({
  authorId: z.string(),
  authorName: z.string().optional(),
  author: UserProfileSchema.nullable(),
  content: z.string(), // ユーザーが入力した文字列
  translatedContents: z.array(z.string()), // ユーザーが入力した文字列を翻訳したもの {lang_cd}/{message} という形式 ***PARSED CONTENT IF CURR USER!***
  parsedTranslatedContents: z
    .array(
      z.object({
        // 上記translatedContentsをparseしたもの
        langCd: z.string(),
        content: z.string(),
      })
    )
    .default([]),
  translatedContent: z.string().optional(), // ユーザーの画面に表示される文字列(同じ言語であれば原文、違う言語であればその翻訳を)
  translating: z.boolean(),
  originalLangCd: z.string(),
  translatedLangCd: z.string().optional(),
  contents: z
    .array(MessageContentSchema)
    .nullable()
    .transform((value) => value ?? []), // bot用のメッセージ
  createdAt: z.string(),
  id: z.string(),
  messageConversationId: z.string(),
  dateText: z.string().optional(),
  action: MessageActionSchema,
  user: QcUserSchema,
  reTranslatedContents: z.string(),
  reTranslateRequestIdMap: z.string(),
  reTranslateCompleteMap: z.string(),
  order: z.number(),
  isGuestUnread: z.boolean(),
  isMasked: z.boolean().optional(),
  displayTo: z.string().nullable().optional(), // 'guest' or 'staff'
  manualMaskingStatus: z.string().optional(),
  linkedMessageId: z.string().nullable().optional(),
  llmVersion: z.string().optional(),
  isReportRequired: z.boolean(),
  image: z.any().optional(),
  lamondoSystemMessage: z.any().optional(),
  isLastMessage: z.boolean().optional(),
});
